/**
 * Convert object to search param string (parameters are alphabetized)
 * Note: there is no special handling for nested objects or arrays
 * @param {Object} object  The search param object to serialize
 * @returns {String}
 */
export function stringify(object) {
	const params = new URLSearchParams(object);
	params.sort();
	const searchString = params.toString();
	if (searchString) {
		return '?' + searchString.replace(/\+/g, '%20');
	}
	return '';
}

/**
 * Convert a search param string into an object
 * Note: duplicate params such as "a=1&a=2" or "a[]=1&a[]=2" don't work
 * @param {String} string  The search param string to deserialize
 * @returns {Object}
 */
export function parse(string) {
	if (String(string).charAt(0) === '?') {
		string = string.slice(1);
	}
	if (String(string).includes('?')) {
		string = new URL(string).search;
	}
	const params = new URLSearchParams(string || '');
	const object = {};
	for (const [key, value] of params) {
		object[key] = value;
	}
	return object;
}
